module.exports = __webpack_public_path__ + "static/Singapore-b08ece6b85956b632cfd079870960c25.svg";